import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
    "Purity",
    "Craftsmanship",
    "Artisanal",
    "Zero Impurities",
    "Hand Carved",
];

export default function EditorialRibbon() {
    return (
        <section
            data-testid="editorial-ribbon"
            className="relative border-y border-white/10 bg-obsidian-800 py-6 overflow-hidden"
        >
            <div className="marquee-container">
                <Marquee gradient={false} speed={30} pauseOnHover>
                    {ITEMS.concat(ITEMS).map((item, i) => (
                        <span
                            key={i}
                            className="font-serif-display italic text-ice-400 text-2xl md:text-3xl mx-12 flex items-center gap-12"
                        >
                            {item}
                            <span className="text-amber-glow text-sm not-italic">◆</span>
                        </span>
                    ))}
                </Marquee>
            </div>
        </section>
    );
}
